export const hotjarPages = [
  "/",
  "/tour/3-day-sailing-tour-croatia/",
  "/tour/w-trek-torres-del-paine-tour/",
  "/tour/self-guided-laugavegur-trekking-tour/",
  "/tour/complete-tour-du-mont-blanc-trek/",
  "/tour/drive-newfoundland-north-coast-tour/",
  "/tour/south-korea-pilgrimage-tour/",
  "/tour/amazon-camping-adventure/",
  "/tour/via-degli-dei-bologna-florence-tour/",
  "/tour/julian-alps-hut-trek/",
  "/tour/amalfi-coast-self-guided-walking-tour/",
  "/tours/canada/",
  "/tours/europe/",
  "/tours/cotswolds-tours/",
]
